export let IdentityType = /*#__PURE__*/function (IdentityType) {
  IdentityType["UNKNOWN_IDENTITY_TYPE"] = "UNKNOWN_IDENTITY_TYPE";
  IdentityType["ACCOUNT"] = "ACCOUNT";
  IdentityType["CONTACT"] = "CONTACT";
  IdentityType["ASSISTANT"] = "ASSISTANT";
  return IdentityType;
}({});
//# sourceMappingURL=CreatedBy.js.map